var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAffirmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#afirm-logo-svg)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.434 17.263a8.5 8.5 0 0 1 2.74-11.927 8.42 8.42 0 0 1 8.65 0 8.463 8.463 0 0 1 3.104 3.251 8.504 8.504 0 0 1-.366 8.676h2.365a10.575 10.575 0 0 0-.516-10.218 10.518 10.518 0 0 0-3.815-3.64 10.469 10.469 0 0 0-10.192 0 10.517 10.517 0 0 0-3.815 3.64 10.57 10.57 0 0 0-.516 10.218h2.361Z",
    fill: "#4A4AF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.64 7.616c-1.537 0-3.307.729-4.268 1.497l.876 1.854c.77-.707 2.017-1.312 3.14-1.312 1.068 0 1.656.357 1.656 1.08 0 .483-.39.76-1.13.827-2.769.256-4.922 1.126-4.922 3.26 0 1.693 1.216 2.716 3.217 2.716a3.377 3.377 0 0 0 2.955-1.732v1.455h2.496v-6.1c0-2.52-1.746-3.538-4.02-3.538v-.007Zm-.728 7.965c-.8 0-1.25-.348-1.25-.917 0-1.19 1.44-1.476 3.33-1.476 0 1.244-.829 2.393-2.081 2.393h.001Z",
    fill: "#060809"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "afirm-logo-svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 2.085h21v15.453H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffirmLogo);
export default __webpack_public_path__ + "static/media/affirm-logo.23bea77757907e8a011edbb9d01e8b30.svg";
export { ForwardRef as ReactComponent };